/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorRow from 'base/components/labrador/Row';

export const DynamicLabradorRow: typeof LabradorRow = (props) => {
    return <ErrorBoundary><LabradorRow {...props} /></ErrorBoundary>;
}
export type DynamicLabradorRowProps = PropsFromComponent<typeof LabradorRow>;
